import { useDispatch } from "react-redux";
import {
  getactiveNominals,
  getClientBankNominals,
  getDdaList,
  getNominalsJournalList,
  getOfficeBankNominals,
} from "../../actions/nominals.action.js";
import {
  getCurrentTransactionperiods,
  getTransactionperiods,
} from "../../actions/transactionperiod.action.js";
import { getActiveFixedFeeHeaders } from "../../actions/fixedFeeHeader.action";
import { getActiveCurrency } from "../../actions/currency.action";
import { getActiveApplications } from "actions/application.action";

export const usePreComponentCalls = () => {
  const dispatch = useDispatch();
  const handleCalls = (data) => {
    if (data === "All Postings" || data === "Batch Posting") {
      dispatch(getOfficeBankNominals());
      dispatch(getactiveNominals());
      dispatch(getClientBankNominals());
      dispatch(getDdaList());
    } else if (data === "Office Postings") {
      dispatch(getOfficeBankNominals());
      dispatch(getactiveNominals());
      dispatch(getClientBankNominals());
      dispatch(getDdaList());
    } else if (data === "Client Postings") {
      dispatch(getOfficeBankNominals());
      dispatch(getactiveNominals());
      dispatch(getClientBankNominals());
      dispatch(getDdaList());
    } else if (data === "Billing") {
      dispatch(getActiveFixedFeeHeaders());
      dispatch(getactiveNominals());
    } else if (data === "Office Allocations") {
      dispatch(getOfficeBankNominals());
    } else if (data === "Nominal Ledger") {
      dispatch(getactiveNominals());
    } else if (data === "Journal Posting") {
      dispatch(getNominalsJournalList());
    } else if (data === "Pay Disbursement") {
      dispatch(getOfficeBankNominals());
    } else if (data === "Transaction Period") {
      dispatch(getCurrentTransactionperiods());
      dispatch(getTransactionperiods());
    } else if (data === "Chit Request") {
      dispatch(getOfficeBankNominals());
      dispatch(getactiveNominals());
      dispatch(getClientBankNominals());
      dispatch(getDdaList());
    } else if (data === "Clients") {
      dispatch(getActiveCurrency());
    } else if (data === "Filters") {
      dispatch(getActiveApplications());
    }
  };
  return { handleCalls };
};
